<div class="reminder-notification" [class.hidden]="hidden" cdkDrag [cdkDragFreeDragPosition]="dragPosition" cdkDragBoundary=".mat-tab-body-active">
    <div class="header">
        <div class="handle" cdkDragHandle></div>
        <div class="buttons-container">
            <fa-icon [icon]="minimizeIcon" class="button" (click)="onMinimize()"></fa-icon>
            <fa-icon [icon]="closeIcon" class="button" (click)="onClose()"></fa-icon>
        </div>
    </div>
    <div class="content">
        <span class="title">{{ title }}</span>
        <span class="text">{{ text }}</span>
        <span class="since-date">{{ creationDate | avmTimeSpent }}</span>
    </div>
</div>
